module.exports = __webpack_public_path__ + "static/media/start_investing_se.ec413670.jpg";